import React, { createContext, useState, useContext } from "react";

interface TestEmailContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  modelId: any;
  setModelId: (modelId: any) => void;
}

export const TestEmailContext = createContext<TestEmailContextType>({  
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  modelId: null,
  setModelId: () => {},
});

interface TestEmailProviderProps {
  children: React.ReactNode;
}

export const TestEmailProvider: React.FC<TestEmailProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState<any>({});
  const [modelId, setModelId] = useState<any>(null);


  const value = {
    showModal,
    setShowModal,
    backendFormErrors,
    setBackendFormErrors,
    modelId,
    setModelId,
  };
  return (
    <TestEmailContext.Provider value={value}>
      {children}
    </TestEmailContext.Provider>
  );
};
